import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const PlusIcon = ({
  width = "24",
  height = "24",
  color = "#1D3E70",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 13H5.5V11H11.5V5H13.5V11H19.5V13H13.5V19H11.5V13Z"
          fill={color}
          opacity={opacity}
        />
      </svg>
    </IconWrapper>
  );
};
